import request from './request'

const api = {
  area: 'area',
  companies: 'companies',
  company: 'company',
  code: 'code',
  card: 'card',
  series: 'series',
  versions: 'versions',
  sites: 'sites',
  addCard: 'add/card',
  login: 'login',
  order: 'order',
  orders: 'orders',
  policy: 'policy'
}

/**
 * 行政区域数据
 * @param {*} params
 * @returns
 */
export function getArea(params) {
  return request({
    url: api.area,
    method: 'get',
    params
  })
}

/**
 * 门店
 */
export function getCompanyList(params) {
  return request({
    url: api.companies,
    method: 'get',
    params
  })
}

export function getCompanyDetail(params) {
  return request({
    url: api.company,
    method: 'get',
    params
  })
}
/**
 * 发送验证码
 */
export function sendSmsCode(data) {
  return request({
    url: api.code,
    method: 'post',
    data
  })
}

/**
 *
 * 质保查询
 */
export function queryCard(data) {
  return request({
    url: api.card,
    method: 'post',
    data
  })
}

/**
 * 系列
 */

export function getSeriesList(params) {
  return request({
    url: api.series,
    method: 'get',
    params
  })
}

/**
 * 型号
 */

export function getVersionList(params) {
  return request({
    url: api.versions,
    method: 'get',
    params
  })
}

/**
 * 装贴位置
 */

export function getSiteList(params) {
  return request({
    url: api.sites,
    method: 'get',
    params
  })
}

/**
 * 订单详情
 */

export function getOrderDetail(params) {
  return request({
    url: api.order,
    method: 'get',
    params
  })
}

/**
 * 创建质保卡
 */
export function addCard(data) {
  return request({
    url: api.addCard,
    method: 'post',
    data
  })
}

/**
 * 登录
 */
export function login(data) {
  return request({
    url: api.login,
    method: 'post',
    data
  })
}

/**
 * 订单列表
 * @param {*} data
 * @returns
 */
export function getOrderList(params) {
  return request({
    url: api.orders,
    method: 'get',
    params
  })
}

/**
 * 新增订单
 */
export function addOrder(data) {
  return request({
    url: api.orders,
    method: 'post',
    data
  })
}

/**
 * 删除订单
 */
export function delOrder(data) {
  return request({
    url: api.order,
    method: 'delete',
    data
  })
}

/**
 * 隐私政策
 */

export function getPolicyDetail(params) {
  return request({
    url: api.policy,
    method: 'get',
    params
  })
}
